import { InfiniteData } from "@tanstack/react-query";
import { ProgramStatus } from "../../../constants";
import { useProgramListFilterContext } from "../../../contexts/ProgramListFilterContext";
import {
  useOptimisticUpdateMutation,
  predicateQueryKeyByParams,
} from "../../../hooks/useOptimisticUpdateMutation";
import CoachProgramsService from "../../../services/CoachProgramsService";
import { COACH_PROGRAMS_LIST_QUERY_KEY } from "../CoachProgramsListScreen";
import {
  IPaginatedListOfProgramDto,
  ProgramDto,
} from "@growth-machine-llc/stridist-api-client";
import { INFINITE_PAGINATED_DATA_UPDATERS } from "../../../utils/optimisticUpdate";

export const useChangeProgramFolderMutation = () => {
  const filterOutProgram = INFINITE_PAGINATED_DATA_UPDATERS.filterOutItem;

  return useOptimisticUpdateMutation({
    mutationFn: CoachProgramsService.changeProgramFolder,
    queryKey: [COACH_PROGRAMS_LIST_QUERY_KEY],
    optimisticUpdater: {
      updateFn: (oldData: InfiniteData<IPaginatedListOfProgramDto>, params) =>
        filterOutProgram<ProgramDto>(oldData, params.programId),
      predicateFn: (queryKey, context) =>
        !predicateQueryKeyByParams(queryKey, { folderId: context.folderId }) &&
        !predicateQueryKeyByParams(queryKey, { folderId: null }),
    },
    invalidateQueryOptions: {
      enabled: true,
      predicateFn: (queryKey, context) =>
        predicateQueryKeyByParams(queryKey, {
          folderId: context.folderId,
        }),
    },
  });
};
